<template>
    <div :class="{ card }">



        <div :class="{ 'card-header': card }">
            <h5 v-if="!hideTitle"
                style="border-bottom:none">
                קביעת פגישה
            </h5>
        </div>

        <div :class="{ 'card-body': card }">


            <div v-if="actual_summaryView"
                 class="planupMeetingFormSummaryView">



                <div class="mb-2">
                    שם הפגישה:
                    {{ meeting.title }}
                </div>

                <!-- נקבעה על ידי: who set the meeting -->
                <div v-if="createdByText"
                     class="planupMeetingFormCreatedBy">
                    <i class="fa-regular fa-user"></i>
                    {{ createdByText }}
                </div>


                <div @click="actual_summaryView = false; $emit('switchToSmallModal')"
                     style="color:#ab8ce4;cursor:pointer;margin-bottom:10px;"
                     v-if="actual_summaryView">

                    ערוך פרטי פגישה
                </div>
                <div class="row"
                     style="margin-bottom:10px;">

                    <div class="col-4">

                        <i class="fa-regular fa-calendar"></i>
                        &nbsp;
                        יום
                        {{ $globals.dayOfWeekFromDate(meeting.date) }}

                        {{ $globals.niceDate(meeting.date) }}
                        בשעה
                        {{ meeting.time }}

                    </div>


                    <div class="col-4">

                        <i class="fa-solid fa-location-dot"></i>
                        &nbsp;
                        {{ meeting.place && meeting.place.name }}

                    </div>



                    <div class="col-4">

                        <i class="fa-solid fa-users"></i>
                        &nbsp;
                        <span v-for="crewMember in meeting.crewMembers">
                            {{ crewMember.name }},
                        </span>

                    </div>

                </div>



                <div>
                    <i class="fa-regular fa-note-sticky"></i>
                    &nbsp;
                    {{ meeting.comments }}
                </div>


                <!-- סטטוס הפגישה: what came of it (התקיימה / הבריזו / בוטלה ...) - saved at once -->
                <div class="planupMeetingFormStatus">
                    <div class="planupMeetingFormStatusTitle">
                        מה קרה בפגישה?
                        <span style="color:#ab8ce4;cursor:pointer;float:left;font-weight:normal"
                              @click="$refs.QuickEditPlanupMeetingStatuses.show()">
                            ניהול מהיר
                        </span>
                    </div>
                    <MeetingStatusChips :value="meeting.meetingStatusId"
                                        :disabled="savingStatus"
                                        @input="pickStatus"></MeetingStatusChips>

                    <!-- the customer pressed אישור הגעה on the meeting's link (for this date and time) -->
                    <div v-if="customerConfirmedText"
                         class="planupMeetingFormConfirmed">
                        <i class="fa-solid fa-circle-check"></i>
                        {{ customerConfirmedText }}
                    </div>

                    <div v-if="waitsForNewDate"
                         class="planupMeetingFormReschedule">
                        <span>
                            <i class="fa-solid fa-rotate-right"></i>
                            הפגישה מחכה לתאריך חדש
                        </span>
                        <button type="button"
                                class="btn btn-primary btn-sm"
                                @click="$emit('reschedule', meeting)">
                            קביעת פגישה חדשה במקומה
                        </button>
                    </div>
                </div>





                <hr>
                <br>

                <h5 style="float:right;border-bottom:none">
                    סיכום פגישה
                </h5>

                <div style="float:right;margin-right:15px;position:relative;top:2px;">

                    <span style="color:#ab8ce4;cursor:pointer;user-select:none"
                          @click="$refs.summaryFieldsPopup.toggle()">
                        <i class="fa-solid fa-plus"
                           style="position:relative;top:1px"></i>
                        הוסף פרמטר
                    </span>

                    <TemplateFieldsPopup ref="summaryFieldsPopup"
                                         style="position:absolute;top:28px;right:0;z-index:300"
                                         :sections="summaryFieldSections"
                                         @insert="insertSummaryField"></TemplateFieldsPopup>

                </div>

                <div style="margin-bottom:30px;">

                    <div class="col-4"
                         style="float:left">


                        <Multiselect style="z-index:200;position:relative;"
                                     selectedLabel=""
                                     deselect-label=""
                                     :allow-empty="false"
                                     label="name"
                                     track-by="id"
                                     :custom-label="$handlers.documentsHandler.templateDisplayName"
                                     placeholder="בחרו תבנית לסיכום פגישה"
                                     selectLabel=""
                                     v-model="summaryTemplate"
                                     :options="$store.state.documents.meetingSummaryTemplates">
                            <template slot="noResult">לא נמצאו תוצאות</template>
                            <template slot="noOptions">אין אפשרויות</template>
                        </Multiselect>
                    </div>


                    <div style="clear:both"></div>

                    <EditDocument class="planupMeetingFormDocumentEditor"
                                  v-if="meeting.summary"
                                  :uniqueForEvent="true"
                                  :inModal="true"
                                  ref="editSummary"
                                  :key="summaryDocument.content"
                                  :document="summaryDocument"></EditDocument>


                    <!-- Meeting-summary attachments (build spec §7) -->
                    <div style="margin-top:14px;">
                        <label class="form-label" style="display:block;margin-bottom:6px;">{{ $t('attachments') }}</label>
                        <input type="file" multiple @change="onPickFiles" />
                        <ul v-if="meeting.attachments && meeting.attachments.length"
                            style="list-style:none;padding:0;margin:8px 0;">
                            <li v-for="(f, i) in meeting.attachments" :key="i" style="padding:3px 0;">
                                <span style="cursor:pointer;color:#6c8cff;" @click="downloadAttachment(f)">{{ f.title }}</span>
                                <i class="fa-regular fa-trash-can" style="color:#999;cursor:pointer;margin-right:8px;"
                                   @click="removeAttachment(f)"></i>
                            </li>
                        </ul>
                        <div v-if="uploadingAttachment" style="color:#868686;font-size:13px;">{{ $t('uploading') }}…</div>
                    </div>



                </div>




            </div>


            <div class="row"
                 v-if="!actual_summaryView">

                <!-- נקבעה על ידי: who set the meeting (an existing one) -->
                <div v-if="createdByText"
                     class="col-12">
                    <div class="planupMeetingFormCreatedBy">
                        <i class="fa-regular fa-user"></i>
                        {{ createdByText }}
                    </div>
                </div>




                <div class="col-md-6">
                    <div class="mb-3">
                        <label class="form-label">
                            {{ $t('planupMeetingTypes') }}
                            <span style="color:#ab8ce4;cursor:pointer;float:left"
                                  @click="$refs.QuickEditPlanupMeetingTypes.show()">
                                ניהול מהיר
                            </span>
                        </label>

                        <QuickEdit ref="QuickEditPlanupMeetingTypes"
                                   :title="$t('QuickEditPlanupMeetingTypes')"
                                   controller="planup-meeting-types"
                                   listName="planupMeetingTypes">
                        </QuickEdit>
                        <Multiselect selectedLabel=""
                                     deselect-label=""
                                     label="name"
                                     track-by="id"
                                     placeholder=""
                                     @tag="$handlers.listsHandler.createListItem($event, 'planupMeetingTypes', 'planup-meeting-types', meeting, 'planupMeetingType')"
                                     selectLabel=""
                                     tagPlaceholder="הקישו אנטר ליצירת  סוג פגישה חדש"
                                     :taggable="true"
                                     v-model="meeting.meetingType"
                                     @select="meetingTypePicked"
                                     :options="$store.state.planupMeetingTypes.filter(x => !x.hidden)">
                            <template slot="noResult">לא נמצאו תוצאות</template>
                            <template slot="noOptions">אין אפשרויות</template>
                        </Multiselect>
                    </div>
                </div>









                <div class="col-md-6">
                    <div class="mb-3">
                        <label class="form-label">
                            שם הפגישה
                        </label>
                        <input v-model="meeting.title"
                               class="form-control">

                        <span class="formErrorText"
                              v-if="meeting.errors">
                            {{ meeting.errors.title }}
                        </span>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="mb-3">
                        <label class="form-label">
                            תאריך
                        </label>
                        <div class="mb-3">
                            <EventDatePicker :tabs="[1]"
                                             :placeHolder="$globals.niceDate(meeting.date)"
                                             @setTime="meeting.time = $event"
                                             @singleDate="meeting.date = $event"></EventDatePicker>

                            <span class="formErrorText"
                                  v-if="meeting.errors">
                                {{ meeting.errors.date }}
                            </span>
                        </div>

                    </div>
                </div>

                <div class="col-md-2">
                    <div class="mb-3">
                        <label class="form-label">
                            שעת התחלה
                        </label>
                        <div class="mb-3">
                            <!-- 
                            <input type="time"
                                   class="form-control"
                                   v-model="meeting.time"
                                   style="text-align:right"> -->


                            <WheelTimePicker v-model="meeting.time"></WheelTimePicker>


                            <!-- <flatPickr ref="meetingTimePicker"
                                       :config="{ enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true }"
                                       v-model="meeting.time"></flatPickr> -->
                        </div>

                    </div>
                </div>

                <div class="col-md-2">
                    <div class="mb-3">
                        <label class="form-label">
                            שעת סיום
                        </label>
                        <div class="mb-3">
                            <!-- 
                            <input type="time"
                                   class="form-control"
                                   v-model="meeting.time"
                                   style="text-align:right"> -->


                            <WheelTimePicker v-model="meeting.endTime"></WheelTimePicker>


                            <!-- <flatPickr ref="meetingTimePicker"
                                       :config="{ enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true }"
                                       v-model="meeting.time"></flatPickr> -->
                        </div>

                    </div>
                </div>

                <div class="col-md-3">
                    <div class="mb-3">
                        <label class="form-label">
                            מקום הפגישה
                            <span style="color:#ab8ce4;cursor:pointer;float:left"
                                  @click="$refs.QuickEditMeetingPlaces.show()">
                                ניהול מהיר
                            </span>
                        </label>
                        <QuickEdit ref="QuickEditMeetingPlaces"
                                   :title="$t('QuickEditMeetingPlaces')"
                                   controller="meeting-places"
                                   listName="meetingPlaces">

                        </QuickEdit>
                        <Multiselect selectedLabel=""
                                     deselect-label=""
                                     :allow-empty="false"
                                     label="name"
                                     track-by="id"
                                     placeholder=""
                                     @tag="$handlers.listsHandler.createListItem($event, 'meetingPlaces', 'meeting-places', meeting, 'place')"
                                     selectLabel=""
                                     tagPlaceholder="הקישו אנטר ליצירת מקום פגישה חדש"
                                     :taggable="true"
                                     v-model="meeting.place"
                                     :options="$store.state.meetingPlaces.filter(x => !x.hidden)">
                            <template slot="noResult">לא נמצאו תוצאות</template>
                            <template slot="noOptions">אין אפשרויות</template>
                        </Multiselect>
                    </div>
                </div>

                <div class="col-md-3">
                    <div class="mb-3">
                        <label class="form-label">
                            {{ $t('crewMembers') }}
                            <span style="color:#ab8ce4;cursor:pointer;float:left"
                                  @click="$refs.QuickEditCrewMembers.show()">
                                ניהול מהיר
                            </span>
                        </label>

                        <!-- <QuickEdit ref="QuickEditCrewMembers"
                                   :title="$t('QuickEditCrewMembers')"
                                   controller="crew-members"
                                   listName="crewMembers">
                        </QuickEdit> -->


                        <QuickSuperEdit @updateList=""
                                        ref="QuickEditCrewMembers"
                                        :title="$t('QuickEditCrewMembers')"
                                        listName="crewMembers"
                                        controller="crew-members"
                                        :bulkSaveFilterFunction="$handlers.listsHandler.bulkSave_filterCrewMembers"
                                        :fields="$store.state.fieldsForQuickSuperEditCrewMembers">
                        </QuickSuperEdit>


                        <Multiselect selectedLabel=""
                                     deselect-label=""
                                     label="name"
                                     track-by="id"
                                     :multiple="true"
                                     placeholder=""
                                     @tag="$handlers.listsHandler.createListItem($event, 'crewMembers', 'crew-members', meeting, 'crewMembers', true)"
                                     selectLabel=""
                                     tagPlaceholder=""
                                     :taggable="true"
                                     v-model="meeting.crewMembers"
                                     :options="$store.state.crewMembers.filter(x => !x.hidden)">
                            <template slot="noResult">לא נמצאו תוצאות</template>
                            <template slot="noOptions">אין אפשרויות</template>
                        </Multiselect>
                    </div>
                </div>



                <div class="col-md-3"
                     v-for="cf in meetingCustomFields"
                     :key="'cf' + cf.id">
                    <CustomFieldInput :field="cf" :owner="meeting"></CustomFieldInput>
                </div>


                <!-- סטטוס הפגישה of a meeting that exists already - saved at once -->
                <div class="col-12"
                     v-if="meeting.id">
                    <div class="mb-3">
                        <label class="form-label"
                               style="display:block">
                            {{ $t('planupMeetingStatuses') }}
                            <span style="color:#ab8ce4;cursor:pointer;float:left"
                                  @click="$refs.QuickEditPlanupMeetingStatuses.show()">
                                ניהול מהיר
                            </span>
                        </label>
                        <MeetingStatusChips :value="meeting.meetingStatusId"
                                            :disabled="savingStatus"
                                            @input="pickStatus"></MeetingStatusChips>

                        <div v-if="customerConfirmedText"
                             class="planupMeetingFormConfirmed">
                            <i class="fa-solid fa-circle-check"></i>
                            {{ customerConfirmedText }}
                        </div>
                    </div>
                </div>


                <!-- a new meeting of a customer who has a meeting waiting for a new date (הבריזו / נדחתה):
                     the new one is set in its place - the latest one is ticked, the old one then leaves
                     מעקב פגישות's "לקביעה מחדש" list -->
                <div class="col-12"
                     v-if="!meeting.id && rescheduleCandidates.length">
                    <div class="planupMeetingFormRescheduleOf">
                        <div class="planupMeetingFormRescheduleOfTitle">
                            <i class="fa-solid fa-rotate-right"></i>
                            הפגישה נקבעת במקום:
                        </div>
                        <label v-for="candidate in rescheduleCandidates"
                               :key="candidate.id"
                               class="planupMeetingFormRescheduleOfOption"
                               :data-meeting-id="candidate.id"
                               @click.prevent="toggleRescheduleOf(candidate.id)">
                            <span class="planup-checkbox planup-checkbox-purple"
                                  :class="{ checked: meeting.rescheduleOfId == candidate.id }">
                                <i class="fa fa-check"></i>
                            </span>
                            <span>{{ candidateText(candidate) }}</span>
                            <MeetingStatusPill :statusId="candidate.meetingStatusId"></MeetingStatusPill>
                        </label>
                    </div>
                </div>


                <div class="col-12">
                    <div class="mb-3">
                        <div class="mb-2">
                            הערות
                        </div>

                        <textarea v-model="meeting.comments"
                                  style="height:200px;"
                                  class="form-control"></textarea>
                    </div>
                </div>




            </div>



            <div v-if="actual_summaryView">
                <label style="user-select: none;cursor:pointer"
                       @click="createTask = !createTask">


                    <span style="position:relative;top:1px;"
                          class="planup-checkbox planup-checkbox-purple"
                          :class="{ checked: createTask }">
                        <i class="fa fa-check"></i>
                    </span>


                    צור משימה למעקב
                </label>
            </div>



            <!-- ניהול מהיר of סטטוסי פגישות - one for both views -->
            <QuickSuperEdit ref="QuickEditPlanupMeetingStatuses"
                            :title="$t('QuickEditPlanupMeetingStatuses')"
                            listName="planupMeetingStatuses"
                            controller="planup-meeting-statuses"
                            :bulkSaveFilterFunction="$handlers.listsHandler.bulkSave_planupMeetingStatuses"
                            :fields="$store.state.fieldsForQuickSuperEditPlanupMeetingStatuses">
            </QuickSuperEdit>

            <div style="float:right">
                <br>
                <span style="cursor:pointer"
                      v-if="meeting.id"
                      @click="deleteMeeting">
                    <i class="fa-regular fa-trash-can"></i>
                    מחק פגישה
                </span>
            </div>

            <div class="pull-right">


                <button @click="saveMeeting(true)"
                        class="btn btn-primary"
                        v-if="customer && onCustomerPage()">

                    שמור ועבור לפרטי האירוע
                </button>


                &nbsp;


                <button @click="saveMeeting()"
                        class="btn btn-primary"
                        v-if="actual_summaryView">

                    שמור
                </button>



                <button v-if="!actual_summaryView"
                        class="btn btn-primary"
                        @click="saveMeeting()">
                    {{ saveButtonTextIsContinue ? 'המשך' : 'שמור' }}
                </button>







            </div>

        </div>

    </div>
</template>
<script>
import flatPickr from "vue-flatpickr-component";
import QuickEdit from '../QuickEdit/QuickEdit.vue';
import Multiselect from 'vue-multiselect';
import EventDatePicker from '../EventDatePicker/EventDatePicker.vue';
import EditDocument from '../Documents/EditDocument';
import DocumentsHandler from "../../modules/DocumentsHandler";
import TemplateFieldsHandler from "../../modules/TemplateFieldsHandler";
import TemplateFieldsPopup from '../Common/TemplateFieldsPopup.vue';
import { orderContactsBrideFirst } from "../../modules/contactOrdering";
import QuickSuperEdit from '../QuickEdit/QuickSuperEdit.vue';
import WheelTimePicker from '../Common/WheelTimePicker.vue';
import axiosV2, { apiPost } from "../../core/http/axios_api_v2";
import CustomFieldInput from '../CustomFields/CustomFieldInput.vue';
import MeetingStatusChips from './MeetingStatusChips.vue';
import MeetingStatusPill from './MeetingStatusPill.vue';

export default {
    name: 'PlanupMeetingForm',
    data() {


        // let contactMails = [];

        // for (let i = 0; i < this?.meeting?.customer?.contacts?.length; i++) {


        //     if (!this?.meeting.customer.contacts[i].email)
        //         continue;


        //     contactMails.push({
        //         email: this?.meeting.customer.contacts[i].email,
        //         name: this?.meeting.customer.contacts[i].firstName,
        //     })
        //     this.meeting.notifyMailAddress.push({
        //         email: this?.meeting.customer.contacts[i].email,
        //         name: this?.meeting.customer.contacts[i].firstName,
        //     })
        // }

        return {

            meetingEndTimeObject: null,

            createTask: false,

            // contactMails,

            summaryTemplate: null,

            loadingSummaryFromTemplate: false,

            actual_summaryView: this.summaryView,
            summaryDocument: null,

            dontShowPopupForChangeSummaryIfEqualsThis: null,

            uploadingAttachment: false,

            //סטטוס הפגישה is being saved (the chips wait)
            savingStatus: false,

            //the customer's meetings that wait for a new date (GET meeting/reschedule-candidates) - a new
            //meeting can be set in place of one; for an open meeting: does it still wait
            rescheduleCandidates: [],
            rescheduleCandidatesKey: null,
            rescheduleCandidatesMeeting: null,

        }
    },

    watch: {


        'meeting.time': function(newVal,endVal) {

            if (!newVal)
                return;

            if (true || !this.meeting.endTime) {
                let [hours, minutes] = newVal.split(':');
                if (hours==23)
                    return;
                hours = +hours+1;
                this.meeting.endTime = hours + ':' + minutes;

            }

        },


        summaryTemplate(newVal, oldVal) {


            //null means we are just not displaying the form with a new meeting loaded into it
            if (newVal == null)
                return;


            //if we are "changed back" after a cancel, without this line it loops
            if (newVal == this.dontShowPopupForChangeSummaryIfEqualsThis)
                return;

            this.$swal({
                title: 'בטוחים שרוצים להחליף תבנית?',
                // text: 'כל השינויים שעשיתם יעלמו.',
                confirmButtonText: 'כן',
                cancelButtonText: 'לא',
                confirmButtonColor: '#ab8ce4',
                showCancelButton: true,

            }).then(() => {

                DocumentsHandler.getDocument(newVal?.id, summaryTemplateDocument => {

                    // this is very important, when we pull a new document template, we don't want to override existing documents when saving, so remove id
                    DocumentsHandler.templateToDocument(summaryTemplateDocument);


                    // fill the template's {{parameters}} with the actual meeting + event values
                    summaryTemplateDocument.content = TemplateFieldsHandler.fillTemplate(
                        summaryTemplateDocument.content,
                        TemplateFieldsHandler.buildFieldMappings(this.meeting, this.event, this.customer)
                    );


                    this.summaryDocument = summaryTemplateDocument;


                    this.dontShowPopupForChangeSummaryIfEqualsThis = null;


                })

            }).catch(() => {
                this.summaryTemplate = oldVal;
                this.dontShowPopupForChangeSummaryIfEqualsThis = oldVal;
            })


        },

        meeting() {

            this.createTask = false;

            this.summaryTemplate = null;
            this.summaryDocument = this.meeting?.summary?.name ? this.meeting?.summary : DocumentsHandler.generateLocalEmptyDocument();

            this.loadRescheduleCandidates();
        },

        //QuickMeetingModal.show() hands the customer over after the meeting
        customer() {
            this.loadRescheduleCandidates();
        },
    },


    props: ['meeting', 'hideTitle', 'card', 'saveButtonTextIsContinue', 'summaryView', 'customer', 'event'],

    mounted() {
        this.loadRescheduleCandidates();
    },

    computed: {
        currentStatus() {
            return this.$handlers.meetingHandler.statusOf(this.meeting);
        },

        //"הלקוח אישר הגעה · 2/11 10:15" - the customer's אישור הגעה on the meeting's link, only while it is
        //for the meeting's date and time as they are now (customerConfirmedSlot, 'YYYY-MM-DD HH:MM')
        customerConfirmedText() {

            return this.$handlers.meetingHandler.customerConfirmedText(this.meeting);
        },

        //the status asks for a new date and no meeting was set in its place yet (a meeting with no
        //customer is not on the customer's list - the button is there for it all the same)
        waitsForNewDate() {

            if (!this.meeting || !this.meeting.id || !this.currentStatus || !this.currentStatus.needsReschedule)
                return false;

            if (!this.customerId())
                return true;

            return this.rescheduleCandidates.some(candidate => candidate.id == this.meeting.id);
        },

        //"נקבעה על ידי מעין מלכה · 2/11/2026 09:16" - who set the meeting, '' when not known
        createdByText() {
            return this.$handlers.meetingHandler.createdByText(this.meeting);
        },

        meetingCustomFields() {
            return (this.$store.state.customFieldDefinitions || []).filter(function(d) {
                return d.appliesTo === 'meeting' && !d.isHidden;
            });
        },

        summaryFieldSections() {

            let sections = [{ title: 'פגישה', fields: TemplateFieldsHandler.meetingFields }];

            if (this.event)
                sections.push({ title: 'אירוע', fields: TemplateFieldsHandler.eventFields });

            sections.push({ title: 'לקוח', fields: TemplateFieldsHandler.customerFields });
            sections.push({ title: 'כללי', fields: TemplateFieldsHandler.generalFields });

            return sections.concat(TemplateFieldsHandler.bookingFieldSections());
        }
    },
    methods: {


        // סטטוס הפגישה, saved at once (POST meeting/:id/status) - the whole meeting is not sent
        async pickStatus(statusId) {

            if (!this.meeting.id || this.savingStatus)
                return;

            let previous = this.meeting.meetingStatusId || null;
            this.$set(this.meeting, 'meetingStatusId', statusId || null);
            this.savingStatus = true;

            try {
                await this.$handlers.meetingHandler.setMeetingStatus(this.meeting.id, statusId);
                this.$emit('statusChanged', this.meeting);
                // a status that asks for a new date: is the meeting still waiting for one
                this.rescheduleCandidatesKey = null;
                this.loadRescheduleCandidates();
            } catch (e) {
                this.$set(this.meeting, 'meetingStatusId', previous);
                this.AlertError('שמירת הסטטוס נכשלה');
            }

            this.savingStatus = false;
        },


        customerId() {
            let customer = (this.meeting && this.meeting.customer) || this.customer;
            return (customer && customer.id) || null;
        },


        // once per meeting + customer: a new meeting (the place-of list), or an open one whose status asks
        // for a new date (the button)
        async loadRescheduleCandidates() {

            let customerId = this.customerId();
            let needed = this.meeting && customerId && (!this.meeting.id || (this.currentStatus && this.currentStatus.needsReschedule));

            if (!needed) {
                this.rescheduleCandidates = [];
                this.rescheduleCandidatesKey = null;
                return;
            }

            // a new meeting is a new object every time (its id is null) - the object itself is the key
            let key = customerId + ':' + (this.meeting.id || 'new');
            if (this.rescheduleCandidatesMeeting === this.meeting && key === this.rescheduleCandidatesKey)
                return;
            this.rescheduleCandidatesMeeting = this.meeting;
            this.rescheduleCandidatesKey = key;

            let meeting = this.meeting;
            let candidates;
            try {
                candidates = await this.$handlers.meetingHandler.getRescheduleCandidates(customerId);
            } catch (e) {
                candidates = [];
            }

            // the form moved on to another meeting meanwhile
            if (meeting !== this.meeting)
                return;

            this.rescheduleCandidates = Array.isArray(candidates) ? candidates : [];

            // a new meeting is set in place of the latest one waiting (ticked, can be unticked) - unless
            // it came with one ("קביעת פגישה חדשה במקומה")
            if (!meeting.id && this.rescheduleCandidates.length && typeof meeting.rescheduleOfId == 'undefined')
                this.$set(meeting, 'rescheduleOfId', this.rescheduleCandidates[0].id);
        },


        toggleRescheduleOf(meetingId) {
            this.$set(this.meeting, 'rescheduleOfId', this.meeting.rescheduleOfId == meetingId ? null : meetingId);
        },


        candidateText(candidate) {
            let parts = [candidate.title || 'פגישה'];
            let m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(candidate.day || ''));
            if (m)
                parts.push(m[3] + '/' + m[2] + '/' + m[1] + (candidate.time ? ' ' + candidate.time : ''));
            return parts.join(' - ');
        },


        // the customer card's own form (saving moves its tabs) - not the one of מעקב פגישות
        onCustomerPage() {
            return !!this.$globals.findComponent('CustomerPage');
        },


        deleteMeeting() {

            this.$swal({
                title: 'האם למחוק את הפגישה?',
                confirmButtonText: 'כן',
                cancelButtonText: 'לא',
                confirmButtonColor: '#ab8ce4',
                showCancelButton: true,
            })
                .then(() => {
                    this.$handlers.meetingHandler.deleteMeeting(this.meeting.id)
                }).then(() => {
                    window.location.reload();
                })
        },


        addNotifyMailAddress(email) {

            this.meeting.notifyMailAddress.push({
                email,
                name: email
            })



        },

        resetSummaryViewToPropValue() {
            this.actual_summaryView = this.summaryView
        },


        //picking a type names the meeting after it: "<type> עם <bride> ו<groom>". Only a pick
        //here does - this used to be a watcher on meeting.meetingType, which also fired whenever a
        //meeting was loaded into the form, so a name fixed by hand came back on every open (and
        //was saved with the summary). Messages that need the type alone use {{סוג הפגישה}}
        meetingTypePicked(type) {

            if (!type)
                return;

            if (!this.customer) {
                this.meeting.title = type.name;
                return;
            }


            // Bride (כלה) before groom (חתן) — shared ordering mechanism, see contactOrdering.js
            let contactsBrideFirst = orderContactsBrideFirst(this.customer.contacts);

            if (!contactsBrideFirst.length || !contactsBrideFirst[0].firstName) {
                this.meeting.title = type.name;
                return;
            }

            this.meeting.title = type.name + ' עם ' + contactsBrideFirst[0].firstName;

            if (contactsBrideFirst[1] && contactsBrideFirst[1].firstName)
                this.meeting.title += ' ' + 'ו' + contactsBrideFirst[1].firstName;
        },


        //inserts the actual value of a {{parameter}} into the summary editor at the caret
        insertSummaryField(field) {

            let mappings = TemplateFieldsHandler.buildFieldMappings(this.meeting, this.event, this.customer);

            if (this.$refs.editSummary)
                this.$refs.editSummary.insertText(mappings[field] || '');
        },

        // ── Meeting-summary attachments (build spec §7) ──
        onPickFiles(e) {
            const files = e && e.target && e.target.files ? Array.from(e.target.files) : [];
            if (!files.length) return;
            if (!this.meeting.attachments) this.$set(this.meeting, 'attachments', []);
            this.uploadingAttachment = true;
            const uploads = files.map(file => {
                const formData = new FormData();
                formData.append('file', file);
                formData.append('title', file.name);
                if (this.meeting.id) formData.append('meetingId', this.meeting.id);
                return apiPost('files/uploadFile', formData, true).then(uploadedFileId => {
                    const fileExtension = file.name.indexOf('.') > -1 ? file.name.split('.').pop() : '';
                    this.meeting.attachments.push({ uploadedFileId, title: file.name, fileExtension });
                });
            });
            Promise.all(uploads)
                .then(() => { this.uploadingAttachment = false; if (e && e.target) e.target.value = ''; })
                .catch(() => { this.uploadingAttachment = false; if (this.AlertError) this.AlertError(); });
        },

        removeAttachment(f) {
            if (!this.meeting.attachments) return;
            const i = this.meeting.attachments.indexOf(f);
            if (i > -1) this.meeting.attachments.splice(i, 1);
        },

        downloadAttachment(f) {
            axiosV2('/uploaded-files/' + f.uploadedFileId).then(res => {
                const uploaded = res && res.data ? res.data : {};
                const link = document.createElement('a');
                link.href = `data:application/octet-stream;base64,${uploaded.base64Content}`;
                link.download = (uploaded.title || f.title) + '.' + (uploaded.fileExtension || f.fileExtension);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });
        },

        saveMeeting(goToEventTab) {

            if (!this.$handlers.meetingHandler.validateMeeting(this, this.meeting))
                return false;

            if (this.actual_summaryView) {
                this.meeting.summary.content = this.$refs?.editSummary?.getDocumentAfterEdits();
                this.meeting.summary.groupName = 'meetingSummary'
                this.meeting.summary.name = 'סיכום פגישה ' + this.meeting.title;
            }


            if (!this.actual_summaryView && (this.customer?.contacts?.length || this.meeting?.crewMembers?.length)){

                this.$root.$emit('showSummonModal', {
                contacts: this.customer?.contacts,
                crewMembers: this.meeting?.crewMembers,
                title: this.meeting?.title,
                meetingType: (this.meeting.meetingType && this.meeting.meetingType.name) || '',
                location: this.meeting?.place?.name,
                date: new Date(this.meeting?.date),
                time: this.meeting?.time,
                endTime: this.meeting?.endTime,
                event: this.event,
                //for the meeting's links ({{קישור לאישור הפגישה}}...) - a new meeting has its id once saved
                meeting: this.meeting,

            });
            }



            this.$emit('saveMeeting');


            //open the follow-up task modal only after the parent hid the meeting modal,
            //so the stacked bootstrap modals don't fight over the body state
            if (this.actual_summaryView && this.createTask) {

                let task = this.$handlers.tasksHandler.generateLocalEmptyTask();
                task.description = 'מעקב: \n\n' + this.meeting.summary.content;
                task.name = 'מעקב פגישה: ' + this.meeting.title;

                //the meeting only carries a customer when it was attached client-side - fall back to the
                //customer prop, otherwise the task is saved orphaned and never shows on the customer page
                task.customer = this.meeting.customer || this.customer;
                planup.$root.$emit('openTaskModal', task)

                this.createTask = false;

            }


            if (!this.customer)
                return;

            // goToEventTab() resolves to פרטי העסקה for inventory businesses, פרטי האירוע otherwise.
            // מעקב פגישות's קבע מחדש uses this form too - there is no card to move then
            const customerPage = this.$globals.findComponent('CustomerPage');
            if (!customerPage)
                return;
            if (goToEventTab)
                customerPage.goToEventTab();
            else
                customerPage.setActiveTab('customerPageGeneralInfoTab');
        },

    },
    components: { Multiselect, QuickEdit, EventDatePicker, flatPickr, EditDocument, QuickSuperEdit, WheelTimePicker, CustomFieldInput, TemplateFieldsPopup, MeetingStatusChips, MeetingStatusPill }
}
</script>
<style>
.planupMeetingFormStatus {
    margin-top: 16px;
    padding: 12px 14px;
    border: 1px solid #eef0f6;
    border-radius: 12px;
    background: #fbfaff;
}

.planupMeetingFormStatus .planupMeetingFormStatusTitle {
    margin-bottom: 10px;
    font-weight: 600;
    color: #2a3142;
}

.planupMeetingFormReschedule {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 12px;
    padding-top: 10px;
    border-top: 1px dashed #e3def3;
    color: #b45f06;
    font-weight: 600;
}

.planupMeetingFormConfirmed {
    margin-top: 10px;
    color: #1f7a3f;
    font-weight: 600;
    font-size: 14px;
}

.planupMeetingFormConfirmed i {
    margin-left: 4px;
}

.planupMeetingFormSummaryView .planupMeetingFormReschedule i {
    color: #f57c00;
}

.planupMeetingFormRescheduleOf {
    margin-bottom: 16px;
    padding: 10px 14px;
    border: 1px solid #fde3c4;
    border-radius: 12px;
    background: #fff9f2;
}

.planupMeetingFormRescheduleOf .planupMeetingFormRescheduleOfTitle {
    margin-bottom: 6px;
    color: #b45f06;
    font-weight: 600;
}

.planupMeetingFormRescheduleOf .planupMeetingFormRescheduleOfTitle i {
    color: #f57c00;
}

.planupMeetingFormRescheduleOf .planupMeetingFormRescheduleOfOption {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 4px 0;
    cursor: pointer;
    user-select: none;
}

.planupMeetingFormCreatedBy {
    margin-bottom: 10px;
    color: #6b7280;
    font-size: 13px;
}

.planupMeetingFormCreatedBy i {
    margin-left: 4px;
    color: #8d63da;
}

.planupMeetingFormSummaryView .ql-container {
    aspect-ratio: unset !important;
}

.planupMeetingFormSummaryView .quillEditorToolbarWrapper {
    width: 100% !important
}

.planupMeetingFormSummaryView i {
    color: rgb(119, 119, 119);
}


.planupMeetingFormSummaryView .ql-container.ql-container {
    margin-top: 0 !important
}


.planupMeetingFormSummaryView .ql-container.ql-container {
    margin-top: 0 !important
}

.planupMeetingFormSummaryView .ql-container.ql-snow.ql-container.ql-snow {

    padding-top: 30px !important;
    padding-bottom: 30px !important;
    min-height: 200px;
    box-sizing: content-box;
}

.ql-blank {
    min-height: 200px;
}

.planupMeetingFormDocumentEditor .ck-content {
    width: 100% !important;
    padding-top: 40px !important;
}

.planupMeetingFormDocumentEditor {
    position: relative;
    top: -5px;
}
</style>